import { type AnchorHTMLAttributes, memo, type PropsWithChildren, useCallback } from 'react';

import { mergePersistentParams } from '@cx-modules/utils';

import { useMatchesCouponContext } from '../../hooks';
import { trackEvent } from '../../utils';

// import { AccaSubevent, useSelectSubeventById } from '@oc-uk/stores/accumulator';
// import { useAllOddsUrl } from '../../hooks';
import { BetContent, BetOuterWrapper, BetWrapper } from './style';

interface BetLinkProps {
  awayTeamName: string;
  homeTeamName: string;
  requestUrl: string;
  subeventId: number;
  url: string;
}

const BetLink = ({
  awayTeamName,
  children,
  homeTeamName,
  requestUrl,
  subeventId,
  url,
}: PropsWithChildren<BetLinkProps>) => {
  const analyticsDataLayer = useMatchesCouponContext(state => state.analyticsDataLayer);
  const analyticsImpressionEventData = useMatchesCouponContext(state => state.analyticsImpressionEventData);
  const disableMatchLinks = useMatchesCouponContext(state => state.disableMatchLinks);
  const eventId = useMatchesCouponContext(state => state.eventId);
  const eventName = useMatchesCouponContext(state => state.eventName);

  const handleClick = useCallback(() => {
    trackEvent(
      'matches_coupon_match_click',
      {
        awayTeam: awayTeamName,
        eventId,
        eventName,
        homeTeam: homeTeamName,
        subeventId,
        ...analyticsImpressionEventData,
      },
      analyticsDataLayer,
    );
  }, [analyticsDataLayer, analyticsImpressionEventData, awayTeamName, eventId, eventName, homeTeamName, subeventId]);

  if (disableMatchLinks) {
    return (
      <BetOuterWrapper>
        <BetContent data-testid="match-link" title={`${homeTeamName} v ${awayTeamName}`}>
          {children}
        </BetContent>
      </BetOuterWrapper>
    );
  }

  const processedUrl = url.replace('/in-running', '');
  const linkAttr: AnchorHTMLAttributes<HTMLAnchorElement> = {
    href: mergePersistentParams(processedUrl, requestUrl),
    onClick: handleClick,
    rel: 'noopener',
  };

  return (
    <BetOuterWrapper>
      <BetWrapper data-testid="match-link" title={`${homeTeamName} v ${awayTeamName}`} {...linkAttr}>
        {children}
      </BetWrapper>
    </BetOuterWrapper>
  );
};

export default memo(BetLink);
